import { useState } from 'react';

import LogoLoader from 'components/LogoLoader';
import Router from 'next/router';

export const PageLoader = () => {
    const [pageIsLoading, setPageIsLoading] = useState(false);

    Router.events.on('routeChangeStart', () => setPageIsLoading(true));
    Router.events.on('routeChangeComplete', () => setPageIsLoading(false));
    Router.events.on('routeChangeError', () => setPageIsLoading(false));

    return (
        <>
            <style jsx global>{`
                #nprogress {
                    display: none !important;
                }
            `}</style>
            <LogoLoader width={35} isLoading={pageIsLoading} />;
        </>
    );
};
